var MAX_TABLET_WIDTH = 1279;
var MAX_MOBILE_WIDTH = 719;

export { MAX_MOBILE_WIDTH, MAX_TABLET_WIDTH };
